import { ClassProvider, Injectable } from '@angular/core';
import { NgbInputDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import dayjs from 'common/dayjs';

@Injectable()
export class CmInputDatepickerConfig extends NgbInputDatepickerConfig {
  constructor() {
    super();
  }

  override maxDate = {
    day: dayjs().get('date'),
    month: dayjs().get('month') + 1,
    year: dayjs().get('year') + 100,
  };

  override minDate = {
    day: dayjs().get('date'),
    month: dayjs().get('month') + 1,
    year: dayjs().get('year') - 100,
  };
}
export const NGB_DATEPICKER_INPUT_CONFIG: ClassProvider = {
  provide: NgbInputDatepickerConfig,
  useClass: CmInputDatepickerConfig,
};
